import { type Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";
import { z } from "zod";

type ExtraConditionId = Branded<string, "ExtraConditionId">;

const {
    factory: extraConditionIdFactory,
    assert: isExtrasConditionId,
    zodSchema: extraConditionIdZodSchema,
} = genericId<ExtraConditionId>("extras_condition__");

const extrasConditionOnlyOnPremiseZodSchema = z.object({
    _id: extraConditionIdZodSchema,

    _type: z.literal("EXTRAS_CONDITION"),
    type: z.literal("EXTRAS_CONDITION_ONLY_ON_PREMISE"),
});

const extrasConditionZodSchema = extrasConditionOnlyOnPremiseZodSchema;

type ExtrasCondition = z.infer<typeof extrasConditionZodSchema>;
type ExtrasConditionOnlyOnPremise = z.infer<
    typeof extrasConditionOnlyOnPremiseZodSchema
>;

const extrasConditionOnlyOnPremiseFactory =
    (): ExtrasConditionOnlyOnPremise => {
        return {
            _id: extraConditionIdFactory(),
            _type: "EXTRAS_CONDITION",
            type: "EXTRAS_CONDITION_ONLY_ON_PREMISE",
        };
    };

//Wip
type ExtraProductCondition = {
    _id: string;
    _type: "EXTRAS_PRODUCT_CONDITION";
};

export {
    extrasConditionOnlyOnPremiseFactory,
    extrasConditionZodSchema,
    isExtrasConditionId,
};
export type { ExtraProductCondition, ExtrasCondition };
